<template>
    <div class="modal-dialog detail__modal" :class="{ 'modal-dialog-open': modal }">
      <div class="modal-content">
        <div class="modal-body-promotion" :class="{ 'modal-body-open': modal }">
          <div class="detail__modal-header">
              <div>
                <font-awesome-icon
              @click="closeModal()"
              :icon="closeIcon"
              class="close-icon"
            />
              <h1 class="detail__title">
                <slot name="title-detail"></slot>
              </h1>
              </div>
            </div>
          <div class="text-modal-content">
            <slot name="content-detail"></slot>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
  export default {
    name: "DetailModal",
    props:['modalShow'],
    data() {
      return {
        closeIcon: faCircleXmark,
        mod1: true,
        mod: true,
      };
    },
    computed: {
      modal(){
        return this.modalShow
      }
    },
    methods: {
      closeModal() {
        this.$emit('modalHide')
      },
    },
    mounted() {
      /*  setTimeout(() => {
          this.mod1=this.modal
          }, 200);
          setTimeout(() => {
          this.mod=this.modal
          }, 200); */
    },
  };
  </script>